import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Technology from '../components/Technology';
import Projects from '../components/Projects';
import NationalProducts from '../components/NationalProducts';
import Testimonials from '../components/Testimonials';
import Certifications from '../components/Certifications';
import Blog from '../components/Blog';
import Contact from '../components/Contact';
import usePageMetadata from '../hooks/usePageMetadata';

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  usePageMetadata({
    title: 'TOLSOL | Toldos y p\u00e9rgolas a medida en Madrid',
    description:
      'Soluciones de protecci\u00f3n solar personalizadas: toldos, p\u00e9rgolas bioclim\u00e1ticas y cerramientos de alta calidad para hogares y negocios en Madrid.',
  });

  useEffect(() => {
    if (location.state?.sectionId) {
      const sectionId = location.state.sectionId;
      requestAnimationFrame(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      });
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return (
    <>
      <Hero />
      <About />
      <Services />
      <Technology />
      <NationalProducts />
      <Projects />
      <Testimonials />
      <Certifications />
      <Blog />
      <Contact />
    </>
  );
};

export default Home;


